/* global $ */
/* global URLS */
/* global gettext */

(function (scope) {
  "use strict";

  var PrintToolbarView = (scope.PrintToolbarView = function (
    controller,
    design
  ) {
    this.controller = controller;
    this.design = design;
    this.$el = $("#PrintToolbarView");
    this.fullscreen = false;
    this.viewerHelpDisplayed = false;
    //variable use to check if the cursor come from the help icon
    // we need this for checking if we need to delay the tool bar view to show or not
    this.is_mouseFromHelp = false;

    this.$toolbarViews = $("#PrintToolbarView .toolbar-views");

    //this.$el.on('change', '#PrintViewMode', this.changeView.bind(this));
    this.$el.on(
      "mouseenter",
      ".toolbar-views",
      this.displayViewsSelector.bind(this)
    );
    this.$el.on(
      "click",
      ".toolbar-views",
      this.displayViewsSelector.bind(this)
    );
    this.$el.on(
      "mouseleave",
      ".toolbar-views",
      this.hideViewsSelector.bind(this)
    );
    this.$el.on(
      "click",
      ".toolbar-views ul li:not(.disabled):not(.selected)",
      this.selectView.bind(this)
    );
    this.$el.on("click", "#print-favorite", this.favorite.bind(this));
    this.$el.on("click", "#print-share", this.share.bind(this));
    this.$el.on("click", "#print-help", this.toggleViewerHelp.bind(this));
    this.$el.on("mouseenter", "#print-help", this.mouseOnViewerHelp.bind(this));
    this.$el.on(
      "mouseleave",
      "#print-help",
      this.mouseLeaveViewerHelp.bind(this)
    );
    this.$el.on(
      "click",
      ".viewer-help .viewer-help-close",
      this.toggleViewerHelp.bind(this)
    );
    this.$el.on("click", ".reset-position-viewer", this.toggleReset.bind(this));

    this.$el.on(
      "click",
      ".show-help-modal-tool",
      this.toggleShowModal.bind(this)
    );

    //use only for better performance
    this.$el.on("click", ".viewer-help-how-to a", this.toggleTour.bind(this));
    this.$el.on(
      "click",
      ".message-need-help .viewer-help-close",
      this.hideHelpMessage.bind(this)
    );

    this.checkFavorite();
  });

  /**
   * toggle show/hide viewer help
   * {evt} jquery event or null if directly called
   * {force} if true for the viewerhelp to hide
   * @private
   */
  PrintToolbarView.prototype.toggleViewerHelp = function (evt, force) {
    if (this.viewerHelpDisplayed || force) {
      $(".viewer-help", this.$el).hide();
      this.viewerHelpDisplayed = false;
    } else {
      $(".viewer-help", this.$el).show();
      this.viewerHelpDisplayed = true;

      //hide the message for new user that appear the first time you go on the print page
      this.hideHelpMessage();
    }
  };

  /**
   * toggle reset the model position
   * @private
   */
  PrintToolbarView.prototype.toggleReset = function () {
    this.controller.toggleResetModelPosition();
  };

  /**
   * show the selectors view
   * @private
   */
  PrintToolbarView.prototype.displayViewsSelector = function () {
    //if the cursor come from the help icon we don't display imidiatly the too bar view
    if (this.is_mouseFromHelp) {
      return;
    }
    this.$toolbarViews.children("ul").show();
  };

  /**
   * hide the selectors view
   * @private
   */
  PrintToolbarView.prototype.hideViewsSelector = function () {
    this.$toolbarViews.children("ul").hide();
  };

  /**
   * toggle controller to force the modal to show
   * @public
   */
  PrintToolbarView.prototype.toggleShowModal = function () {
    //when we click on the show help modal, we call the control to toggle the modal with the "forceShowModal" set to true
    this.controller.toggleModalTool(true);
  };

  /**
   * toggle the tour
   * @public
   */
  PrintToolbarView.prototype.toggleTour = function () {
    this.controller.toggleTour(true);
    this.toggleViewerHelp(null, true);
  };

  /**
   * show message for new user
   * @private
   */
  PrintToolbarView.prototype.showHelpMessage = function () {
    $(".message-need-help", this.$el).show();
  };

  /**
   * hide message for new user
   * @private
   */
  PrintToolbarView.prototype.hideHelpMessage = function () {
    $(".message-need-help", this.$el).hide();
  };

  /**
   * Show the help tool
   * @public
   */
  PrintToolbarView.prototype.showHelpTool = function () {
    $(".show-help-modal-tool", this.$el).show();
  };

  /**
   * Show the help tool
   * @public
   */
  PrintToolbarView.prototype.hideHelpTool = function () {
    $(".show-help-modal-tool", this.$el).hide();
  };

  /**
   * called when the cursor is entering the help icon
   */
  PrintToolbarView.prototype.mouseOnViewerHelp = function () {
    //if we enter the help icon we set the var to true
    this.is_mouseFromHelp = true;
  };

  /**
   * called when the cursor is leaving the help icon
   */
  PrintToolbarView.prototype.mouseLeaveViewerHelp = function () {
    // if the cursor leave the whelp icon we listen the toobarview mouseenter and mouseleave
    //if we enter the toolbarview we set a var at true
    //otherwise false
    var needDisplayViewsSelector = false;
    this.$toolbarViews.on(
      "mouseenter",
      function (evt) {
        needDisplayViewsSelector = true;
      }.bind(this)
    );

    this.$toolbarViews.on(
      "mouseleave",
      function (evt) {
        needDisplayViewsSelector = false;
      }.bind(this)
    );

    //after 150 ms, we removed the listener and set is_mouseFromHelp to false to make the tool bar view show again immediately
    setTimeout(
      function () {
        this.$toolbarViews.off("mouseenter");
        this.$toolbarViews.off("mouseleave");
        this.is_mouseFromHelp = false;
        //but if the cursor did enter the tool bar views then we show the tool bar view
        if (needDisplayViewsSelector) {
          this.displayViewsSelector();
        }
      }.bind(this),
      150
    );
  };

  /**
   * select the view
   * @private
   */
  PrintToolbarView.prototype.selectView = function (e) {
    //get the new view
    var selectedView = $(e.currentTarget).data("value");

    switch (selectedView) {
      case "solidity-check":
        this.changeView(sculpteo.PrintToolbarView.VIEWS.SOLIDITY_CHECK);
        $("#hollowing-settings, #thickening-settings").css("left", "10px");
        break;
      case "cutaway":
        this.changeView(sculpteo.PrintToolbarView.VIEWS.CUTEWAY);
        $("#hollowing-settings, #thickening-settings").css("left", "10px");
        break;
      case "wireframe":
        this.changeView(sculpteo.PrintToolbarView.VIEWS.WIREFRAME);
        $("#hollowing-settings, #thickening-settings").css("left", "100px");
        break;
      case "default":
        this.changeView(sculpteo.PrintToolbarView.VIEWS.DEFAULT);
        $("#hollowing-settings, #thickening-settings").css("left", "100px");
        break;
    }

    this.hideViewsSelector();
  };

  /**
   * Update the view selector
   * @private
   */
  PrintToolbarView.prototype.updateViewSelector = function (view) {
    //removed the current class selected on the li and add it to the new selected view
    this.$toolbarViews.find("ul li.selected").removeClass("selected");

    var $newSelectedViewSelector = this.$toolbarViews.find(
      "[data-value='" + view + "']"
    );
    $newSelectedViewSelector.addClass("selected");

    // Handles text
    this.$toolbarViews
      .find(".current-view .view-name")
      .text($newSelectedViewSelector.text());

    // Handles icon
    var $visibleIconSpan = this.$toolbarViews.find(
      ".current-view .current-view-icon span"
    );
    $visibleIconSpan.removeClass();
    var newIcon = $newSelectedViewSelector
      .find("[class^='icon-']")
      .attr("class");
    $visibleIconSpan.addClass(newIcon);
  };

  /**
   * Handles view toggle.
   * @public
   */
  PrintToolbarView.prototype.changeView = function (view) {
    //reset all view
    this.resetView();

    //update the selector to match the new view
    this.updateViewSelector(view);

    switch (view) {
      case sculpteo.PrintToolbarView.VIEWS.SOLIDITY_CHECK:
        this.controller.toggleSolidityCheck(true);
        //show overlay message
        this.controller.overlayNotify(
          sculpteo.PrintOverlayNotification.TYPE.SOLIDITY_CHECK,
          gettext("View: Solidity check"),
          false
        );
        break;
      case sculpteo.PrintToolbarView.VIEWS.CUTEWAY:
        this.controller.toggleCutaway(true);
        //show overlay message
        this.controller.overlayNotify(
          sculpteo.PrintOverlayNotification.TYPE.CUTEWAY,
          gettext("View: Cuteway"),
          false
        );
        break;
      case sculpteo.PrintToolbarView.VIEWS.WIREFRAME:
        this.controller.toggleWireframe(true);
        //show overlay message
        this.controller.overlayNotify(
          sculpteo.PrintOverlayNotification.TYPE.WIREFRAME,
          gettext("View: Wireframe"),
          false
        );
        break;
      case sculpteo.PrintToolbarView.VIEWS.DEFAULT:
        //show overlay message
        //this.controller.overlayNotify(sculpteo.PrintOverlayNotification.TYPE.DEFAULT, gettext( "View: Default"), false);
        break;
    }
  };

  /**
   * Reset all views.
   * @private
   */
  PrintToolbarView.prototype.resetView = function () {
    this.controller.toggleSolidityCheck(false);
    this.controller.toggleWireframe(false);
    this.controller.toggleCutaway(false);
  };

  /**
   * makes all selector view available
   * @public
   */
  PrintToolbarView.prototype.resetViewAvailability = function () {
    this.$toolbarViews.find("ul li").removeClass("disabled");
  };

  /**
   * update available view
   * where listArrayViews is an array of all views that are NOT available
   * @public
   */
  PrintToolbarView.prototype.updateViewAvailability = function (
    listArrayViews
  ) {
    var $viewSelector;
    for (var index = 0; index < listArrayViews.length; ++index) {
      $viewSelector = this.$toolbarViews.find(
        "[data-value='" + listArrayViews[index] + "']"
      );
      $viewSelector.addClass("disabled");
    }
  };

  /**
   * Handles favotite button
   * @private
   */
  PrintToolbarView.prototype.favorite = function (e) {
    e.preventDefault();

    $.post(URLS.favorite + this.design.design_uuid).done(
      function (json) {
        this.notify(json.message);
        this.updateFavoriteIcon(json);
      }.bind(this)
    );
  };

  /**
   * Ask server if the design is in user's favorites
   * @private
   */
  PrintToolbarView.prototype.checkFavorite = function () {
    $.getJSON(
      URLS.favorite + this.design.design_uuid,
      this.updateFavoriteIcon.bind(this)
    );
  };

  /**
   * Update favorite icon based on design's status
   * @private
   * @param {object} json - server's response
   */
  PrintToolbarView.prototype.updateFavoriteIcon = function (json) {
    $("#print-favorite span", this.$el).toggleClass(
      "icon-star",
      json.is_favorite
    );
    $("#print-favorite span", this.$el).toggleClass(
      "icon-star_border",
      !json.is_favorite
    );
  };

  /**
   * Handles share button. Copy current location to clipboard
   * @private
   */
  PrintToolbarView.prototype.share = function (e) {
    var input = $("<input>")
      .attr("type", "text")
      .attr("id", "clipboard")
      .css({ position: "absolute", top: "-1000px", left: "-1000px" })
      .val(document.location.origin + document.location.pathname)
      .insertAfter(this.$el);

    document.querySelector("#clipboard").select();
    document.execCommand("copy");

    this.notify(gettext("Copied to clipboard"));
    input.remove();
  };

  /**
   * Displays a temporary notification in the toolbar
   * @public
   * @param {string} text
   */
  //todo need to be fixed
  PrintToolbarView.prototype.notify = function (text) {
    var $message = $("<span>").addClass("notification").text(text);
    $(".toolbar-notification", this.$el).html($message);
    setTimeout(function () {
      $message.remove();
    }, 2000);
  };

  PrintToolbarView.prototype.showLoadingMessage = function (text) {
    this.$message = $("<span>").addClass("notification").text(text);
    $(".toolbar-notification", this.$el).html(this.$message);
  };

  PrintToolbarView.prototype.hideLoadingMessage = function () {
    this.$message.remove();
  };

  PrintToolbarView.VIEWS = {};
  PrintToolbarView.VIEWS.DEFAULT = "default";
  PrintToolbarView.VIEWS.SOLIDITY_CHECK = "solidity-check";
  PrintToolbarView.VIEWS.CUTEWAY = "cutaway";
  PrintToolbarView.VIEWS.WIREFRAME = "wireframe";
})((window.sculpteo = window.sculpteo || {}));
